import {Component, Input} from '@angular/core';

@Component({
	selector: 'chart-placeholder',
	template: `
    <div class="ph-item chart" [style.height]="height">
      <div class="ph-col-6">
        <div class="ph-row" style="height: 100%;">
          <div style="height: 25%;" class="ph-col-2 card"></div>
          <div class="ph-col-2 empty"></div>
          <div style="height: 80%;" class="ph-col-2 card"></div>
          <div class="ph-col-2 empty"></div>
          <div style="height: 45%;" class="ph-col-2 card"></div>
        </div>
      </div>
      <div class="ph-col-6">
        <div class="ph-row" style="height: 100%;">
          <div style="height: 80%;" class="ph-col-2 card"></div>
          <div class="ph-col-2 empty"></div>
          <div style="height: 90%;" class="ph-col-2 card"></div>
          <div class="ph-col-2 empty"></div>
          <div style="height: 25%;" class="ph-col-2 card"></div>
        </div>
      </div>
    </div>
	`,
})
export class ChartPlaceholderComponent {
	@Input() public height = '400px';
}
